import React, { useState, useEffect, useContext } from "react";
import Papa from "papaparse";
import { useLocation, useParams, NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import ProgressBar from "react-bootstrap/ProgressBar";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./App.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ModalHitos from "./ModalHitos";
import { AppContext } from "./provider/provider";

function Contenido() {
  const [state, setState] = useContext(AppContext);
  const { NombreArea } = useParams();
  const location = useLocation();
  const [iniciativas, setIniciativas] = useState([]);

  const columns = [
    {
      dataField: "Id",
      text: "Product ID",
      hidden: true,
    },
    {
      dataField: "Areas",
      text: "ÁREAS",
      headerClasses: "headerTabla",
      classes: "agrupacion",
      headerStyle: {
        width: "250px",
        minWidth: "250px",
        color: "#fff",
      },
      formatter: (cell, row) => {
        return (
          <div
            className="iniciativa-card"
            style={{
              background: "rgba(255, 255, 255, 0.8)",
              borderRadius: "15px",
              padding: "25px",
              margin: "10px 0",
              boxShadow: "0 8px 25px rgba(0, 0, 0, 0.08)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              transition: "all 0.3s ease",
            }}
          >
            <Row>
              <Col md={7}>
                <div style={{ paddingRight: "15px" }}>
                  <h5
                    className="nombreIniciativa"
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#3d2e66",
                      marginBottom: "12px",
                    }}
                  >
                    {row.NombreIniciativa}
                  </h5>
                  <p
                    style={{
                      color: "#555",
                      fontFamily: "'Work Sans',sans-serif",
                      fontSize: "15px",
                      textAlign: "justify",
                      fontWeight: "400",
                      lineHeight: "1.5",
                      marginBottom: "15px",
                    }}
                  >
                    {row.Descripcion}
                  </p>
                  <div
                    style={{
                      display: "inline-block",
                      cursor: "pointer",
                      padding: "8px 16px",
                      background: "linear-gradient(135deg, #f07f0d, #e6730c)",
                      borderRadius: "20px",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 12px rgba(240, 127, 13, 0.3)",
                    }}
                    onClick={() => {
                      _InformacionModal(row);
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 6px 18px rgba(240, 127, 13, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 4px 12px rgba(240, 127, 13, 0.3)";
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontSize: "0.9rem",
                        fontWeight: "600",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Ver Hitos
                    </span>
                  </div>
                </div>
              </Col>
              <Col
                md={3}
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <ProgressBar
                    now={row.AvanceN}
                    style={{
                      height: "12px",
                      borderRadius: "6px",
                      backgroundColor: "#e9ecef",
                      overflow: "hidden",
                    }}
                  />
                </div>
              </Col>
              <Col
                md={2}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: "0px",
                }}
              >
                <span
                  className="porcentajeBarra"
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#5d428b",
                    textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  {row.Avance}
                </span>
              </Col>
            </Row>
          </div>
        );
      },
    },
    // {
    //   dataField: "barra",
    //   text: "",

    //   headerClasses: "headerTabla",
    //   classes: "agrupacion",
    //   formatter: priceFormatter,
    // },

    // {
    //   dataField: "Avance",
    //   text: "AVANCE DEL ÁREA",
    //   align: "center",
    //   headerStyle: {
    //     width: "180px",
    //     minWidth: "180px",
    //   },
    //   headerClasses: "headerTabla",
    //   classes: "agrupacion",
    // },
  ];

  const [progress, setProgress] = useState(0);
  const [porcentajeTotal, setPorcentajeTotal] = useState(0);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [informacionModal, setInformacionModal] = useState({});
  const [area, setArea] = useState("");

  useEffect(() => {
    if (state?.periodos?.[state.periodoActivo]) {
      console.log("nombre area", NombreArea);
      setArea(NombreArea);
      FiltrarInformacion();
      window.parent.postMessage("scrollToTop", "*");
    }
  }, [state.periodoActivo]);

  const FiltrarInformacion = () => {
    const datos = state?.periodos?.[state.periodoActivo] || {};
    const listaAreas = datos.Areas || [];

    console.log("periodo activo", state.periodoActivo);

    console.log("location", datos);
    //let nombreArea = "Fomento productivo y emprendimiento" || NombreArea;
    //let nombreArea = datos ? datos.NombreArea : NombreArea;
    const nombreArea = location.state?.NombreArea || NombreArea;
    const nombreNormalizado = nombreArea.trim().toLowerCase();
    //console.log("nombreArea", nombreArea);
    //setArea(nombreArea);
    console.log("nombreArea", nombreArea);

    //filter contenis data
    const objArea = listaAreas.find((item) =>
      item.Area.trim().toLowerCase().includes(nombreNormalizado)
    );
    console.log("objArea", objArea);

    //setArea(objArea.Area);

    if (Object.keys(objArea).length > 0) {
      let avance = objArea.Avance?.replace("%", "") || 0;
      console.log("avance", Number(avance));

      PorcentajeTotal(Number(avance));
    }

    if (state) {
      if (datos.Iniciativas && datos.Iniciativas.length > 0) {
        let listaIniciativas = datos.Iniciativas;

        let filterIniciativas =
          listaIniciativas.find((item) => item.Area.includes(nombreArea)) || {};

        console.log("listIniciativas", filterIniciativas);

        if (Object.keys(filterIniciativas).length > 0) {
          let iniciativas = filterIniciativas.Iniciativas || [];

          console.log("iniciativas sin formato", iniciativas);

          let informacionIniciativas_ = [];

          iniciativas.map((item, i) => {
            let obj = {
              Id: i + 1,
              NombreIniciativa: item.NombreIniciativa,
              Descripcion: item.Descripcion,
              Avance: item.Avance,
              AvanceN: Number(item.Avance.replace("%", "")),
              Reporte: item.Reporte ? item.Reporte : "No disponible.",
            };

            informacionIniciativas_.push(obj);
          });

          console.log("Render Iniciativas", informacionIniciativas_);
          setIniciativas(informacionIniciativas_);
        }
      }
    }
  };

  const PorcentajeTotal = (avance) => {
    const interval = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= avance ? avance : prevProgress + 1
      );
    }, 50); // Ajusta el tiempo según necesites

    return () => clearInterval(interval);
  };

  const _InformacionModal = (data) => {
    console.log("Informacion modal fila", data);
    const datos = state?.periodos?.[state.periodoActivo] || {};

    let nombreIniciativa = data.NombreIniciativa;

    let listaHitos = datos.Hitos || [];

    let filterHitos = listaHitos.filter(
      (item) => item.NombreIniciativa === nombreIniciativa
    );

    console.log("filterHitos", filterHitos);

    if (filterHitos.length > 0) {
      let informacionHitos = filterHitos[0].Hitos || [];

      let informacion = {
        Area: area,
        NombreIniciativa: nombreIniciativa,
        Descripcion: data.Descripcion,
        Avance: data.Avance,
        Hitos: informacionHitos,
        Reporte: data.Reporte,
      };

      console.log("informacion", informacion);
      setInformacionModal(informacion);
      //etArea(data.Areas);
      setMostrarModal(true);
    }

    //setArea(row.Areas);
    setMostrarModal(true);
  };

  const Construir = (data) => {
    console.log(data);

    const resultado = {};

    //console.log(nombres);

    //setData(Object.values(resultado));
    //console.log(resultado);
  };

  const expandRow = {
    renderer: (row) => (
      <>
        {row.Iniciativas.map((iniciativa, i) => {
          return (
            <Row
              style={{
                paddingTop: "20px",
                paddingBottom: "15px",
                paddingLeft: "10px",
                border: "1px solid #E0E0E0",
                margin: "0px",
              }}
              key={i}
            >
              <Col md={10}>
                <h5
                  style={{
                    color: "inherit",
                    fontFamily: "'Work Sans',sans-serif",
                    fontWeight: "500",
                  }}
                >
                  {iniciativa.Nombre}
                </h5>
                <p
                  style={{
                    color: "inherit",
                    fontFamily: "'Work Sans',sans-serif",
                    marginBottom: "6px",
                  }}
                >
                  {iniciativa.Descripcion}
                </p>
                <div>
                  <span
                    href="#"
                    style={{
                      fontFamily: "'Work Sans',sans-serif",
                      textDecoration: "none",
                      fontSize: "14px",
                      cursor: "pointer",
                      color: "#ED6A21",
                    }}
                    onClick={() => {
                      console.log("iniciativa", iniciativa);
                      setInformacionModal(iniciativa);
                      //setArea(row.Areas);
                      setMostrarModal(true);
                    }}
                  >
                    Ver Hitos
                  </span>
                </div>
              </Col>
              <Col md={2} style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "700",
                    marginLeft: "25px",
                    color: "#81BA27",
                  }}
                >
                  {iniciativa.Porcentaje}
                </div>
              </Col>
            </Row>
          );
        })}

        {/* <Row
              style={{
                paddingTop: "20px",
                paddingBottom: "15px",
                paddingLeft: "10px",
                border: "1px solid #E0E0E0",
                margin: "0px",
              }}
            >
              <Col md={10}>
                <h5
                  style={{
                    color: "inherit",
                    fontFamily: "'Work Sans',sans-serif",
                    fontWeight: "500",
                  }}
                >
                  Obligación de declarar proyecciones de GEI y medidas de mitigación{" "}
                  {row.id}
                </h5>
                <p
                  style={{ color: "inherit", fontFamily: "'Work Sans',sans-serif" }}
                >
                  Propondremos legislación para que aquellos proyectos productivos
                  que deban someterse a un proceso de evaluación ambiental declaren
                  sus proyecciones de GEI y medidas de mitigación consistentes con
                  el objetivo de carbononeutralidad, y para que la exigencia de que
                  en proyecciones de línea de base se considere el comportamiento
                  futuro de componentes ambientales según diferentes escenarios
                  climáticos.
                </p>
              </Col>
              <Col md={2} style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ fontSize: "3rem", fontWeight: "700" }}>10%</div>
              </Col>
            </Row> */}
      </>
    ),
  };

  function priceFormatter(cell, row) {
    console.log("row", row);

    return (
      <div style={{ paddingTop: "10px" }}>
        <ProgressBar variant="warning" now={row.barra} />
      </div>
    );
  }

  return (
    <Container
      fluid
      style={{ backgroundColor: "transparent", padding: "5px 20px 20px 20px" }}
    >
      {/* Header con navegación y título */}
      <motion.div
        className="modern-container"
        style={{ margin: "15px 0", padding: "25px" }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Row style={{ alignItems: "center" }}>
          <Col md={6} xs={6}>
            <NavLink to={{ pathname: `/Areas` }}>
              <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.98 }}>
                <Button
                  className="btn-modern"
                  style={{
                    width: "170px",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "'Work Sans', sans-serif",
                    textDecoration: "none",
                  }}
                >
                  ◀ Volver atrás
                </Button>
              </motion.div>
            </NavLink>
          </Col>
          <Col md={6} xs={6} style={{ textAlign: "right" }}>
            <span
              className="tituloPeriodo"
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#5d428b",
                background:
                  "linear-gradient(135deg, rgba(93, 66, 139, 0.1), rgba(93, 66, 139, 0.05))",
                padding: "8px 16px",
                borderRadius: "20px",
                border: "1px solid rgba(93, 66, 139, 0.2)",
                textShadow: "0 1px 2px rgba(0,0,0,0.1)",
                backdropFilter: "blur(8px)",
                display: "inline-block",
              }}
            >
              {state.periodoActivo}
            </span>
          </Col>
        </Row>
      </motion.div>

      {/* Sección principal con progreso y título */}
      <motion.div
        className="modern-container"
        style={{ margin: "15px 0", padding: "40px" }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <Row>
          <Col md={12} style={{ textAlign: "center", marginBottom: "30px" }}>
            <motion.h2
              className="tituloArea"
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#5d428b",
                textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                marginBottom: "10px",
              }}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              {area}
            </motion.h2>
          </Col>
          <Col md={12} style={{ display: "flex", justifyContent: "center" }}>
            <motion.div
              className="progress-circle-container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "20px",
              }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
            >
              <div style={{ width: 140, height: 140, marginBottom: "15px" }}>
                <CircularProgressbar
                  value={progress}
                  text={`${progress}%`}
                  strokeWidth={10}
                  styles={buildStyles({
                    pathColor: `#5d428b`,
                    textColor: "#81ba27",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                    textSize: "28px",
                    textWeight: "bold",
                    strokeLinecap: "round",
                    text: {
                      fontWeight: "bold",
                      filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
                    },
                    pathTransition:
                      progress === 0
                        ? "none"
                        : "stroke-dashoffset 0.8s ease 0s",
                  })}
                />
              </div>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#3d2e66",
                  textShadow: "0 1px 2px rgba(0,0,0,0.1)",
                }}
              >
                AVANCE GENERAL
              </span>
            </motion.div>
          </Col>
        </Row>
      </motion.div>
      {/* Sección de iniciativas */}
      <motion.div
        className="modern-container"
        style={{ margin: "15px 0", padding: "0" }}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.8 }}
      >
        <Row
          className="header-gradient-orange"
          style={{
            color: "#fff",
            textAlign: "center",
            padding: "18px 0",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <Col md={7}>
            <motion.h4
              style={{
                margin: "0",
                fontSize: "18px",
                fontWeight: "700",
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 1.0 }}
            >
              INICIATIVAS
            </motion.h4>
          </Col>
          <Col md={5}>
            <motion.h4
              style={{
                margin: "0",
                fontSize: "18px",
                fontWeight: "700",
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 1.0 }}
            >
              % DE AVANCE
            </motion.h4>
          </Col>
        </Row>

        <div style={{ padding: "20px" }}>
          <BootstrapTable
            keyField="Id"
            data={iniciativas}
            columns={columns}
            bordered={false}
            headerClasses="custom-table-header"
          />
        </div>
      </motion.div>
      {Object.keys(informacionModal).length > 0 && (
        <ModalHitos
          MostrarModal={mostrarModal}
          InformacionModal={informacionModal}
          CerrarModal={() => {
            setMostrarModal(false);
            //setArea("");
            setInformacionModal({});
          }}
        />
      )}
    </Container>
  );
}

export default Contenido;
